<template>
  <v-row justify="center">
    <v-dialog v-model="attivo" persistent>
      <v-form
        ref="form"
        @submit.prevent="onSubmit"
        v-model="valid"
        lazy-validation
      >
        <v-card>
          <v-card-title>
            <!--<span class="text-h5">{{ $t("anagrafica.titolo") }}</span>-->
          </v-card-title>
          <v-card-text>
            <v-container>
              <!-- prova -->

              <v-expansion-panels v-model="pannelli" multiple>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <v-chip class="ma-2" label color="primary">
                      {{ $t("anagrafica.titolo") }}
                    </v-chip>

                    <template v-slot:actions>
                      <v-icon color="primary"> $expand </v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field
                          v-model="anagrafica.cognome"
                          v-bind:label="$t('anagrafica.cognome') + '*'"
                          required
                          :rules="[(v) => !!v || $t('campoObbligatorio')]"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="6" md="6">
                        <v-text-field
                          v-model="anagrafica.nome"
                          v-bind:label="$t('anagrafica.nome') + '*'"
                          required
                          :rules="[(v) => !!v || $t('campoObbligatorio')]"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="6" md="6">
                        <v-autocomplete
                          :no-data-text="$t('noData')"
                          v-model="anagrafica.nazioneNascita"
                          :items="dd_nazioni"
                          item-text="DECODIF"
                          item-value="CODICENU"
                          v-bind:label="$t('anagrafica.nazionenascita') + '*'"
                          required
                          :rules="[
                            (v) =>
                              !!(v && v.CODICENU) || $t('campoObbligatorio'),
                          ]"
                          return-object
                        >
                        </v-autocomplete>
                      </v-col>

                      <v-col cols="12" sm="6" md="6">
                        <v-combobox
                          :no-data-text="$t('noData')"
                          v-model="anagrafica.comuneNascita"
                          :items="dd_comuni"
                          item-text="DECODIF"
                          item-value="CODICECOMUNE"
                          v-bind:label="$t('anagrafica.comunenascita') + '*'"
                          required
                          :rules="[validaComune]"
                          @change="nuovoComuneNascita"
                          return-object
                        >
                        </v-combobox>
                      </v-col>

                      <v-col cols="12" sm="4">
                        <v-text-field
                          v-model="anagrafica.dataNascita"
                          :label="$t('anagrafica.datanascita') + '*'"
                          v-mask="'##/##/####'"
                          required
                          :rules="[
                            (v) =>
                              (!!v && !(v.length < 10)) ||
                              $t('campoObbligatorio'),
                            (v) =>
                              checkMaggiorenni(v) ||
                              'Devi avere più di 18 anni',
                          ]"
                        >
                          <template v-slot:prepend>
                            <v-menu
                              v-model="menu2"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">event</v-icon>
                              </template>
                              <v-date-picker
                                v-model="dataNascitaPicker"
                                :locale="$i18n.locale"
                                @input="menu2 = false"
                                :max="
                                  new Date(
                                    Date.now() -
                                      new Date().getTimezoneOffset() * 60000
                                  )
                                    .toISOString()
                                    .substr(0, 10)
                                "
                              ></v-date-picker> </v-menu
                          ></template>
                        </v-text-field>
                        <!--<v-text-field
                    v-model="anagrafica.dataNascita"
                    v-bind:label="$t('anagrafica.datanascita') + '*'"
                    v-mask="'##/##/####'"
                    :rules="[
                      (v) => !!v || $t('campoObbligatorio'),
                      (v) => checkMaggiorenni(v) || 'data non corretta',
                    ]"
                    required
                    ><template v-slot:append> datapick </template>
                    </v-text-field>-->
                      </v-col>
                      <!--<v-col cols="12" sm="2">
                        <v-autocomplete
                          :no-data-text="$t('noData')"
                          v-model="anagrafica.linguaMadre"
                          :items="dd_linguamadre"
                          v-bind:label="$t('anagrafica.linguamadre') + '*'"
                          required
                          :rules="[
                            (v) =>
                              !!(v && v.CODICENU) || $t('campoObbligatorio'),
                          ]"
                          item-text="DESCRIZIONE"
                          item-value="CODICENU"
                          return-object
                        ></v-autocomplete>
                      </v-col>-->
                      <v-col cols="12" sm="4">
                        <v-select
                          @click="carica_StatoCivile"
                          v-model="anagrafica.statoCivile"
                          :items="dd_statocivile"
                          v-bind:label="$t('anagrafica.statocivile') + '*'"
                          required
                          :rules="[
                            (v) =>
                              !!(v && v.CODICENU) || $t('campoObbligatorio'),
                          ]"
                          item-text="DECODIF"
                          item-value="CODICENU"
                          return-object
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="2">
                        <v-select
                          v-model="anagrafica.sesso"
                          :items="[
                            { text: 'M', value: 'M' },
                            { text: 'F', value: 'F' },
                          ]"
                          v-bind:label="$t('anagrafica.sesso') + '*'"
                          required
                          :rules="[
                            (v) => !!(v && v.length) || $t('campoObbligatorio'),
                          ]"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="2">
                        <v-select
                          @click="carica_Religioni"
                          v-model="anagrafica.religione"
                          :items="dd_religioni"
                          v-bind:label="$t('anagrafica.religione') + '*'"
                          item-text="descrbreve"
                          item-value="CODICENU"
                          required
                          :rules="[
                            (v) =>
                              !!(v && v.CODICENU) || $t('campoObbligatorio'),
                          ]"
                          return-object
                        ></v-select>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <v-autocomplete
                          :no-data-text="$t('noData')"
                          v-model="anagrafica.cittadinanza1"
                          :items="dd_cittadinanza"
                          v-bind:label="$t('anagrafica.cittadinanza') + '*'"
                          required
                          :rules="[
                            (v) =>
                              !!(v && v.CODICENU) || $t('campoObbligatorio'),
                          ]"
                          return-object
                          item-text="DECODIF"
                          item-value="CODICENU"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-autocomplete
                          :no-data-text="$t('noData')"
                          :key="anagrafica.cittadinanza2"
                          v-model="anagrafica.cittadinanza2"
                          :items="dd_cittadinanza"
                          v-bind:label="$t('anagrafica.2cittadinanza')"
                          @click:append-outer="cancella('2cittadinanza')"
                          append-outer-icon="mdi-eraser"
                          return-object
                          item-text="DECODIF"
                          item-value="CODICENU"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-autocomplete
                          :no-data-text="$t('noData')"
                          :key="anagrafica.ordineReligioso"
                          v-model="anagrafica.ordineReligioso"
                          :items="dd_ordinireligiosi"
                          v-bind:label="$t('anagrafica.ordinereligioso')"
                          append-outer-icon="mdi-eraser"
                          @click:append-outer="cancella('ordine')"
                          item-text="DECODIF"
                          item-value="CODICENU"
                          return-object
                          :rules="[
                            (v) =>
                              !(
                                !v.CODICENU &&
                                this.anagrafica.statoCivile.CODICENU == 1
                              ) || $t('campoObbligatorio'),
                            (v) =>
                              !(
                                !v.CODICENU &&
                                this.anagrafica.statoCivile.CODICENU == 15
                              ) || $t('campoObbligatorio'),
                          ]"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field
                          v-model="anagrafica.codiceFiscale"
                          v-bind:label="$t('anagrafica.codicefiscale')"
                          required
                          @keyup="uppercase"
                          v-mask="'AAAAAA##A##A###A'"
                          :rules="[
                            (v) => !!checkCF2(v) || $t('anagrafica.CFNoValido'),
                            (v) => checkCF(v) || $t('campoObbligatorio'),
                            (v) => checkCF3(v) || $t('campoObbligatorio'),
                          ]"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <v-autocomplete
                          :no-data-text="$t('noData')"
                          key="anagrafica.diocesi"
                          v-model="anagrafica.diocesi"
                          :items="dd_diocesi"
                          :label="$t('anagrafica.diocesi')"
                          @click:append-outer="cancella('diocesi')"
                          append-outer-icon="mdi-eraser"
                          return-object
                          item-text="DIOCESI"
                          item-value="CODICE"
                          :rules="[
                            (v) =>
                              !(
                                !v.CODICE &&
                                this.anagrafica.statoCivile.CODICENU == 2
                              ) || $t('campoObbligatorio'),
                            (v) =>
                              !(
                                !v.CODICE &&
                                this.anagrafica.statoCivile.CODICENU == 13
                              ) || $t('campoObbligatorio'),
                          ]"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-autocomplete
                          :no-data-text="$t('noData')"
                          @click:append-outer="cancella('collegio')"
                          append-outer-icon="mdi-eraser"
                          v-model="anagrafica.collegio"
                          :items="dd_collegi"
                          :label="$t('anagrafica.collegio')"
                          :key="anagrafica.collegio"
                          return-object
                          item-text="COLLEGIO"
                          item-value="CODICE"
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header disable-icon-rotate>
                    <v-chip class="ma-2" label color="primary">
                      {{ $t("indirizzi.titoloResidenza") }}
                    </v-chip>
                    <template v-slot:actions>
                      <v-icon color="primary"> $expand </v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" sm="4">
                        <v-autocomplete
                          :no-data-text="$t('noData')"
                          v-model="indirizzi.residenza.nazione"
                          :items="dd_nazioni"
                          item-text="DECODIF"
                          item-value="CODICENU"
                          required
                          return-object
                          v-bind:label="$t('indirizzi.nazione') + '*'"
                          :rules="[
                            (v) =>
                              !!(v && v.CODICENU) || $t('campoObbligatorio'),
                          ]"
                        ></v-autocomplete>
                      </v-col>

                      <v-col cols="12" sm="4">
                        <v-combobox
                          :no-data-text="$t('noData')"
                          v-model="indirizzi.residenza.comune"
                          :items="dd_comuni_residenza"
                          item-text="DECODIF"
                          item-value="CODICECOMUNE"
                          v-bind:label="$t('indirizzi.comune') + '*'"
                          required
                          @change="nuovoComuneResidenza"
                          return-object
                          :rules="[
                            (v) =>
                              !!(v && v.DECODIF) || $t('campoObbligatorio'),
                          ]"
                        ></v-combobox>
                      </v-col>
                      <v-col cols="12" sm="1">
                        <v-text-field
                          v-model="indirizzi.residenza.cap"
                          required
                          v-bind:label="$t('indirizzi.cap') + '*'"
                          :rules="[(v) => !!v || $t('campoObbligatorio')]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field
                          v-model="indirizzi.residenza.telefono"
                          v-bind:label="$t('indirizzi.telefono')"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          v-model="indirizzi.residenza.indirizzo"
                          v-bind:label="$t('indirizzi.indirizzo') + '*'"
                          required
                          :rules="[(v) => !!v || $t('campoObbligatorio')]"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header disable-icon-rotate>
                    <v-chip class="ma-2" label color="primary">
                      {{ $t("indirizzi.titoloRecapito") }}
                    </v-chip>
                    <template v-slot:actions>
                      <v-icon color="primary"> $expand </v-icon>
                    </template>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content>
                    <center>
                      <v-btn
                        v-if="indirizzi.residenza.nazione.CODICENU == 1"
                        class="animate__animated animate__zoomIn pa-2 ma-2"
                        color="default darken-1"
                        @click="copiaDatiResidenza"
                        x-small
                      >
                        {{ $t("anagrafica.copiaResidenza") }}
                      </v-btn>
                    </center>
                    <v-row class="text-small">
                      <v-col cols="12" sm="4">
                        <v-autocomplete
                          :no-data-text="$t('noData')"
                          v-model="indirizzi.recapito.nazione"
                          :items="dd_nazioni"
                          item-text="DECODIF"
                          item-value="CODICENU"
                          v-bind:label="$t('indirizzi.nazione') + '*'"
                          required
                          return-object
                          :rules="[
                            (v) =>
                              !!(v && v.CODICENU) || $t('campoObbligatorio'),
                          ]"
                        >
                          <template slot="selection" slot-scope="data">
                            {{ data.item.DECODIF }}
                          </template>
                        </v-autocomplete>
                      </v-col>

                      <v-col cols="12" sm="4">
                        <v-combobox
                          :no-data-text="$t('noData')"
                          v-model="indirizzi.recapito.comune"
                          :items="dd_comuni_recapito"
                          item-text="DECODIF"
                          item-value="CODICECOMUNE"
                          v-bind:label="$t('indirizzi.comune') + '*'"
                          required
                          @change="nuovoComuneRecapito"
                          return-object
                          :rules="[
                            (v) =>
                              !!(v && v.DECODIF) || $t('campoObbligatorio'),
                          ]"
                        >
                          <template slot="selection" slot-scope="data">
                            {{ data.item.DECODIF }}
                          </template>
                        </v-combobox>
                      </v-col>
                      <v-col cols="12" sm="1">
                        <v-text-field
                          v-model="indirizzi.recapito.cap"
                          v-bind:label="$t('indirizzi.cap') + '*'"
                          v-mask="'#####'"
                          required
                          :rules="[
                            (v) => !!v || $t('campoObbligatorio'),
                            (v) =>
                              (!!v && !(v.length < 5)) ||
                              $t('indirizzi.formatoCap'),
                          ]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field
                          v-model="indirizzi.recapito.telefono"
                          v-bind:label="$t('indirizzi.telefono') + '*'"
                          required
                          :rules="[(v) => !!v || $t('campoObbligatorio')]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="indirizzi.recapito.indirizzo"
                          v-bind:label="$t('indirizzi.indirizzo') + '*'"
                          required
                          :rules="[(v) => !!v || $t('campoObbligatorio')]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="indirizzi.recapito.presso"
                          v-bind:label="$t('indirizzi.presso')"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="indirizzi.recapito.cellulare"
                          v-bind:label="$t('indirizzi.cellulare')"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <!-- fine prova-->
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer
              ><small>({{ $t("campiObbligatori") }})</small></v-spacer
            >
            <v-btn color="primary darken-1" @click="validazione">
              {{ $t("conferma") }}
            </v-btn>
            <v-btn color="primary darken-1" text @click="chiudi">
              {{ $t("chiudi") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      elevation="24"
      color="primary"
    >
      <b>{{ $t("checkCampiObbligatori") }}</b>
    </v-snackbar>
  </v-row>
</template>

<script>
import api from "@/services/EventService.js";

export default {
  name: "anagrafica",

  props: {
    attivo: {
      default: false,
      type: Boolean,
    },
  },
  data: () => ({
    snackbar: false,
    timeout: 2000,
    pannelli: [0, 1, 2],
    dialog: true,
    anteprimaFoto: "",
    files: [],
    readers: [],
    dd_nazioni: null,
    dd_comuni: [],
    dd_religioni: null,
    dd_linguamadre: null,
    dd_statocivile: null,
    dd_cittadinanza: null,
    dd_ordinireligiosi: null,
    dd_diocesi: null,
    dd_collegi: null,
    menu2: false,
    dataNascitaPicker: "",
    dd_nazione_recapito: [
      { CODICENU: 1, DECODIF: "ITALIA" },
      { CODICENU: 137, DECODIF: "STATO CITTÀ DEL VATICANO" },
      { CODICENU: 130, DECODIF: "SAN MARINO" },
    ],
    dd_comuni_residenza: [],
    dd_comuni_recapito: [],
  }),
  methods: {
    checkCF(valore) {
      try {
        if (
          this.anagrafica.cittadinanza1.CODICENU === 1 &&
          valore.length != 16
        ) {
          return false;
        }
      } finally {
        console.log("check");
      }
      return true;
    },
    checkCF3(valore) {
      console.log(valore);
      try {
        if (
          this.indirizzi.residenza.nazione.CODICENU === 1 &&
          valore.length != 16
        ) {
          return false;
        }
      } finally {
        console.log("check");
      }
      return true;
    },
    checkCF2(valore) {
      try {
        if (valore) {
          if (valore.length > 0 && valore.length != 16) {
            return false;
          }
        }
      } finally {
        console.log("check");
      }
      return true;
    },
    carica_Religioni() {
      api
        .get("/anagrafiche/religioni/" + this.$i18n.locale + "")
        .then((r) => {
          this.dd_religioni = r.data;
        })
        .catch();
    },

    carica_StatoCivile() {
      api
        .get("/anagrafiche/statocivile/" + this.$i18n.locale + "")
        .then((r) => {
          this.dd_statocivile = r.data;
        })
        .catch();
    },
    nuovoComuneNascita(comune) {
      if (typeof comune === "string" && comune.trim()) {
        const item = this.dd_comuni.find((item) => item.DECODIF === comune);
        if (item) {
          this.item = item;
        } else {
          const nuovoComune = {
            CODICECOMUNE: 0,
            DECODIF: comune,
          };
          this.anagrafica.comuneNascita = nuovoComune;
        }
      }
    },
    nuovoComuneResidenza(comune) {
      if (typeof comune === "string" && comune.trim()) {
        const item = this.dd_comuni.find((item) => item.DECODIF === comune);
        if (item) {
          this.item = item;
        } else {
          const nuovoComune = {
            CODICECOMUNE: 0,
            DECODIF: comune,
          };
          this.indirizzi.residenza.comune = nuovoComune;
        }
      }
    },
    nuovoComuneRecapito(comune) {
      if (typeof comune === "string" && comune.trim()) {
        const item = this.dd_comuni.find((item) => item.DECODIF === comune);
        if (item) {
          this.item = item;
        } else {
          const nuovoComune = {
            CODICECOMUNE: 0,
            DECODIF: comune,
          };
          this.indirizzi.recapito.comune = nuovoComune;
        }
      }
    },
    cancella(campo) {
      switch (campo) {
        case "ordine":
          this.anagrafica.ordineReligioso = { CODICENU: null, DECODIF: "" };
          break;
        case "2cittadinanza":
          this.anagrafica.cittadinanza2 = { CODICENU: null, DECODIF: "" };
          break;
        case "diocesi":
          this.anagrafica.diocesi = { CODICE: null, DIOCESI: "" };
          break;
        case "collegio":
          this.anagrafica.collegio = { CODICE: null, COLLEGIO: "" };
          break;
      }
    },

    copiaDatiResidenza() {
      //this.indirizzi.recapito.text= "ITALIA"
      this.$store.state.indirizzi.recapito.nazione = this.$store.state.indirizzi.residenza.nazione;
      this.$store.state.indirizzi.recapito.comune = this.$store.state.indirizzi.residenza.comune;
      this.indirizzi.recapito.indirizzo = this.indirizzi.residenza.indirizzo;
      this.indirizzi.recapito.cap = this.indirizzi.residenza.cap;
      this.indirizzi.recapito.telefono = this.indirizzi.residenza.telefono;
    },
    checkMaggiorenni(dataNascita) {
      const date18YrsAgo = new Date();
      // Converte il formato dd/mm/yyyy in un oggetto Date
      const [day, month, year] = dataNascita.split("/");
      dataNascita = new Date(year, month - 1, day);
      date18YrsAgo.setFullYear(date18YrsAgo.getFullYear() - 18);
      // vediamo se è maggiorenne
      return dataNascita <= date18YrsAgo;
    },
    uppercase() {
      this.anagrafica.codiceFiscale = this.anagrafica.codiceFiscale.toUpperCase();
    },
    validaComune() {
      return (
        !!(this.anagrafica.comuneNascita != null) ||
        this.$t("campoObbligatorio")
      );
    },
    validaDataNascita() {},
    carica_dd: function() {
      api
        .get("/anagrafiche/nazioni/")
        .then((r) => {
          this.dd_nazioni = r.data;
          /* riga nazione non definita
          this.dd_nazioni.unshift({
            CODICENU: 0,
            DECODIF: "-- Non Definito --",
          });*/

          // ricarico i dati da store, se presenti
          // this.iscrizione.fac_scelta = this.dd_facolta.find(
          // item => item.CODICENU === this.iscrizione_store.facolta.val
          //);
        })
        .catch();

      api
        .get("/anagrafiche/comuni/" + this.anagrafica.nazioneNascita.CODICENU)
        .then((r) => {
          this.dd_comuni = r.data;
          // riga nazione non definita
          this.dd_comuni.unshift({
            CODICECOMUNE: 0,
            DECODIF: this.$t("NonDefinito"),
          });
          // ricarico i dati da store, se presenti
          // this.iscrizione.fac_scelta = this.dd_facolta.find(
          // item => item.CODICENU === this.iscrizione_store.facolta.val
          //);
        })
        .catch();

      api
        .get("/anagrafiche/religioni/" + this.$i18n.locale + "")
        .then((r) => {
          this.dd_religioni = r.data;

          // ricarico i dati da store, se presenti
          // this.iscrizione.fac_scelta = this.dd_facolta.find(
          // item => item.CODICENU === this.iscrizione_store.facolta.val
          //);
        })
        .catch();

      api
        .get("/anagrafiche/statocivile/" + this.$i18n.locale + "")
        .then((r) => {
          this.dd_statocivile = r.data;

          // ricarico i dati da store, se presenti
          // this.iscrizione.fac_scelta = this.dd_facolta.find(
          // item => item.CODICENU === this.iscrizione_store.facolta.val
          //);
        })
        .catch();

      api
        .get("/anagrafiche/lingue/")
        .then((r) => {
          this.dd_linguamadre = r.data;

          // ricarico i dati da store, se presenti
          // this.iscrizione.fac_scelta = this.dd_facolta.find(
          // item => item.CODICENU === this.iscrizione_store.facolta.val
          //);
        })
        .catch();

      api
        .get("/anagrafiche/cittadinanza/")
        .then((r) => {
          this.dd_cittadinanza = r.data;

          // ricarico i dati da store, se presenti
          // this.iscrizione.fac_scelta = this.dd_facolta.find(
          // item => item.CODICENU === this.iscrizione_store.facolta.val
          //);
        })
        .catch();

      api
        .get("/anagrafiche/ordinireligiosi/")
        .then((r) => {
          this.dd_ordinireligiosi = r.data;
          // riga ordine non definito
          this.dd_ordinireligiosi.unshift({
            CODICENU: 9999,
            DECODIF: this.$t("NonDefinito"),
          });

          // ricarico i dati da store, se presenti
          // this.iscrizione.fac_scelta = this.dd_facolta.find(
          // item => item.CODICENU === this.iscrizione_store.facolta.val
          //);
        })
        .catch();

      api
        .get("/anagrafiche/diocesi/")
        .then((r) => {
          this.dd_diocesi = r.data;
          // riga diocesi non definito
          this.dd_diocesi.unshift({
            CODICE: 9999,
            DIOCESI: this.$t("NonDefinito"),
          });
          // ricarico i dati da store, se presenti
          // this.iscrizione.fac_scelta = this.dd_facolta.find(
          // item => item.CODICENU === this.iscrizione_store.facolta.val
          //);
        })
        .catch();

      api
        .get("/anagrafiche/collegi/")
        .then((r) => {
          this.dd_collegi = r.data;
          // riga collegi non definito
          this.dd_collegi.unshift({
            CODICE: 9999,
            COLLEGIO: this.$t("NonDefinito"),
          });
          // ricarico i dati da store, se presenti
          // this.iscrizione.fac_scelta = this.dd_facolta.find(
          // item => item.CODICENU === this.iscrizione_store.facolta.val
          //);
        })
        .catch();

      this.carica_comuni_residenza();
      this.carica_comuni_recapito();
    },

    carica_comuni() {
      /* axios
        .get("/anagrafiche/comuni/"+dd_nazioni)
        .then((r) => {
          this.dd_comuni = r.data;
          // ricarico i dati da store, se presenti
          // this.iscrizione.fac_scelta = this.dd_facolta.find(
          // item => item.CODICENU === this.iscrizione_store.facolta.val
          //);
        })
        .catch();
        */
    },

    async chiudi() {
      //alert("inizio_chiudo")
      if (!this.$refs.form.validate()) {
        await this.$store.dispatch("setStepNoCompletoEvent", 2);
      }
      //alert("chiudo")

      this.attivo = false;
    },
    async validazione() {
      if (this.$refs.form.validate()) {
        await this.$store.dispatch("setStepCompletoEvent", 2);
        this.attivo = false;
      } else {
        this.snackbar = true;
      }
    },

    Preview_image() {
      console.log("files", this.files);
      this.files.forEach((file, f) => {
        this.readers[f] = new FileReader();
        this.readers[f].onloadend = () => {
          let fileData = this.readers[f].result;
          let imgRef = this.$refs.file[f];

          imgRef.src = fileData;
          console.log(fileData);
          // send to server here...
        };

        this.readers[f].readAsDataURL(this.files[f]);
      });
      /*if (e) {
        this.anteprimaFoto = URL.createObjectURL(e);
        this.anagrafica.fototessera = J
      } else{
         this.anteprimaFoto = ""
      }*/
    },
    carica_comuni_residenza() {
      api
        .get("/anagrafiche/comuni/" + this.indirizzi.residenza.nazione.CODICENU)
        .then((r) => {
          this.dd_comuni_residenza = r.data;
        })
        .catch();
    },
    carica_comuni_recapito() {
      api
        .get("/anagrafiche/comuni/" + this.indirizzi.recapito.nazione.CODICENU)
        .then((r) => {
          this.dd_comuni_recapito = r.data;
          // ricarico i dati da store, se presenti
          // this.iscrizione.fac_scelta = this.dd_facolta.find(
          // item => item.CODICENU === this.iscrizione_store.facolta.val
          //);
        })
        .catch();
    },
  },
  computed: {
    anagrafica() {
      return this.$store.state.anagrafica;
    },
    indirizzi() {
      return this.$store.state.indirizzi;
    },
    studiPrevi() {
      return this.$store.state.studiprevi;
    },
  },
  mounted: function() {
    this.carica_dd();
  },

  watch: {
    dataNascitaPicker(newVal) {
      // Converte da formato ISO (yyyy-mm-dd) a formato italiano (dd/mm/yyyy)
      if (newVal) {
        const [year, month, day] = newVal.split("-");
        this.anagrafica.dataNascita = `${day}/${month}/${year}`;
      }
    },
    "anagrafica.dataNascita"(newVal) {
      // Converte da formato italiano (dd/mm/yyyy) a formato ISO (yyyy-mm-dd)
      if (newVal && newVal.length === 10 && newVal.includes("/")) {
        const [day, month, year] = newVal.split("/");
        if (year && year.length === 4 && month && day) {
          this.dataNascitaPicker = `${year}-${month}-${day}`;
        }
      }
    },
    "anagrafica.nazioneNascita": function() {
      //alert(JSON.stringify(this.anagrafica.nazioneNascita));

      api
        .get("/anagrafiche/comuni/" + this.anagrafica.nazioneNascita.CODICENU)
        .then((r) => {
          this.dd_comuni = r.data;
          this.dd_comuni.unshift({
            CODICECOMUNE: 0,
            DECODIF: "-- Non Definito --",
          });
          // ricarico i dati da store, se presenti
          // this.iscrizione.fac_scelta = this.dd_facolta.find(
          // item => item.CODICENU === this.iscrizione_store.facolta.val
          //);
        })
        .catch();
    },

    "anagrafica.collegio": function() {
      this.$store.state.indirizzi.recapito.cap = this.anagrafica.collegio.CAP;
      this.$store.state.indirizzi.recapito.telefono = this.anagrafica.collegio.TELEFONO;
      this.$store.state.indirizzi.recapito.indirizzo = this.anagrafica.collegio.INDIRIZZO;
      this.$store.state.indirizzi.recapito.presso = this.anagrafica.collegio.COLLEGIO;
      this.$store.state.indirizzi.recapito.nazione.CODICENU = this.anagrafica.collegio.NAZIONE;
      this.$store.state.indirizzi.recapito.nazione.DECODIF = this.anagrafica.collegio.nazione_decodif;
      this.$store.state.indirizzi.recapito.comune.CODICECOMUNE = this.anagrafica.collegio.CITTA;
      this.$store.state.indirizzi.recapito.comune.DECODIF = this.anagrafica.collegio.citta_decodif;
    },
    "indirizzi.residenza.nazione": function() {
      //alert(JSON.stringify(this.anagrafica.nazioneNascita));

      this.carica_comuni_residenza();
    },
    "indirizzi.recapito.nazione": function() {
      this.carica_comuni_recapito();
    },
  },
};
</script>
